import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type { ServicesFormInput } from "web_myplann/Portfolio/Forms/ServicesForm/servicesFormSchema";

export const SERVICES_FORM_DEFAULT_VALUES: ServicesFormInput = {
	name: "",
	producer: "",
	product: "",
	contractNumber: "",
	tariff: "",
	commodityService: null,
	unitOfMeasurement: "",
	pricePerUnit: null,
	fixedPriceByFrequency: null,
	paymentFrequency: ClientPortfolioPaymentFrequencyEnum.Monthly,
	depositAmount: null,
	signedAt: null,
	startAt: null,
	endAt: null,
};
